import { render, staticRenderFns } from "./teamWise.vue?vue&type=template&id=17fbaf83&scoped=true&"
import script from "./teamWise.vue?vue&type=script&lang=js&"
export * from "./teamWise.vue?vue&type=script&lang=js&"
import style0 from "./teamWise.vue?vue&type=style&index=0&id=17fbaf83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fbaf83",
  null
  
)

export default component.exports